<script>

  export default {
    props: {
      options: {
        type: null,
        default: () => [
          { value: 'all', text: 'Any', selected: 'all' },
          { value: 'default', text: 'Default', selected: null },
          { value: 'supplier', text: 'Supplier', selected: null },
          { value: 'staff', text: 'Staff', selected: null },
          { value: 'customer', text: 'Customer', selected: null },
          { value: 'finance', text: 'Finance', selected: null },
          { value: 'project', text: 'Project', selected: null },
          { value: 'branch', text: 'Branch', selected: null },
        ]
      },
      filterKey: {
        type: String,
        default: 'type'
      },
      isExpanded: {
        type: Boolean,
        default: false
      },
      defaultFilters: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        addressTypeFilter: this.defaultFilters,
        pivoting: false,
        boundCollapse: false,
        unWatcher: null,
      }
    },
    computed:{
      filterTypes(){
        return this.options.map(el => el.selected).filter(el => el)
      }
    },
    created() {
      this.boundCollapse = Boolean(this.isExpanded)
      this.boundCollapse = !this.boundCollapse

      this.unWatcher = this.createFilterTypesWatcher()
    },
    methods:{
      createFilterTypesWatcher (){
        return this.$watch('filterTypes', function (newVal, oldVal) {

          let filterValue = newVal

          if (newVal && newVal.length > 1 && newVal.indexOf('all') !== -1){
            // disable watcher
            this.unWatcher();
            // currently have 'all' and something else so unselect 'all'
            if (oldVal.indexOf('all') !== -1){
              // remove as small scope added
              // newVal.splice(newVal.indexOf('all'), 1)
              const element = this.options.find(el => el.value === 'all')
              if (element){
                element.selected = false
              }
            }else{
              // newVal = ['all']
              // remove all as 'all' scope added
              this.options.forEach(el => {
                if (el.value !== 'all' && el.selected){
                  el.selected = false
                }
              });
            }
            // re-enable watcher
            this.unWatcher = this.createFilterTypesWatcher();
            filterValue = this.filterTypes;
          }

          const payload = {}
          payload[this.filterKey] = filterValue
          this.$emit('filter', payload)
        })
      },
    }
  }
</script>

<template>
  <div v-bind="$attrs" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-returnType
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter Address Type</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
          default-collapsed
        />
      </h3>
    </div>
    <FabricCollapse
      id="accordion-returnType"
      v-model="boundCollapse"
      default-shown
      hide-header
      :duration="500"
      class="table-filters">
      <div class="block-content">
        <section
          v-for="(option, index) in options"
          :key="`op-${index}`"
          :class="{ 'hr-solid-line': option.value === 'all' }">
          <FabricCheckbox
            v-model="option.selected"
            :value="option.value"
            slot-classes="tw-pl-3 tw-text-black"
          >{{ option.text }}</FabricCheckbox>
        </section>
      </div>
    </FabricCollapse>
  </div>
</template>
